<template>
  <div class="event-skills">
    <modal title="Привязка компетенции" :subtitle="''"
      v-on:close="switchModal"
      v-if="modal">
      <add-skill-to-event v-on:close="switchModal"/>
    </modal>
    <div class="skills-actions">
      <button v-if="permissionsStatus.isEventUpdateAllowed"
        class="ccs-button ccs-button--white ccs-button--small" @click="switchModal">
        <img src="@/assets/icons/add.svg" alt="" class="button-icon">
        Привязать компетенцию
      </button>
    </div>
    <ccs-table :data="eventSkills" :columnsDefs="columnsDefs"
      :defaultActions="defaultActions" @delete="removeSkill">
      <template v-slot:name_rus="props">
        <div class="ccs-tag"
          @click="$router.push({ name: 'skill', params: { skillID: props.row.id }} )">
          {{ props.row.code }}
        </div>
        {{ props.row.name_rus }}
      </template>
    </ccs-table>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

import Table from '@/components/Table.vue';
import Modal from '@/components/Modal.vue';

import AddSkillToEvent from '@/components/modals/events/AddSkillToEvent.vue';

export default {
  name: 'Skills',
  components: {
    'ccs-table': Table,
    Modal,
    AddSkillToEvent,
  },
  data() {
    return {
      modal: false,
      columnsDefs: [{
        name: `name_rus`,
        title: 'Компетенция',
        prop: 'name_rus',
      }, {
        name: `code`,
        title: `Код`,
        prop: `code`,
        align: 'center',
        fontStyle: 'secondary',
      }, {
        name: `main_expert`,
        title: `ФИО Главного эксперта`,
        prop: `status`,
        align: 'left',
      }, {
        name: `tech_expert`,
        title: `ФИО Тех. эксперта`,
        prop: `status`,
        align: 'left',
      }, {
        name: `status`,
        title: `Статус`,
        prop: `status`,
        align: 'left',
        fontStyle: 'secondary',
      }, {
        name: `participants`,
        title: `Участников`,
        prop: `status`,
        align: 'center',
      }, {
        name: `experts`,
        title: `Экспертов`,
        prop: `status`,
        align: 'center',
      }],
    };
  },
  computed: {
    ...mapState('events', ['event', 'eventSkills']),
    ...mapGetters('session', ['permissionsStatus']),
    defaultActions() {
      return {
        isTitleHidden: true,
        delete: this.permissionsStatus.isEventUpdateAllowed,
      };
    },
  },
  methods: {
    ...mapActions('events', ['getEventSkills', 'deleteSkillFromEvent']),
    switchModal() {
      this.modal = !this.modal;
    },
    async removeSkill(skill) {
      try {
        await this.deleteSkillFromEvent(skill);
        this.$toasted.success('Компетенция отвязана');
      } catch (err) {
        this.$toasted.error(err);
      }
    },
  },
  async mounted() {
    await this.getEventSkills();
  },
};
</script>

<style lang="scss" scoped>
.event-skills {
  min-height: 100%;
  min-width: 100%;

  .skills-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .ccs-table {
    margin-top: 20px;
  }

}
</style>
